import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import styles from "./Banner.module.css";

const Banner = () => {
  const banners = [
    "https://i.picsum.photos/id/902/1500/300.jpg?hmac=hw58DyVpfeOK44F5r5xv5NVclzO7Tf5jSR_VYE6MkCA",
    "https://i.picsum.photos/id/1005/1500/300.jpg?hmac=OJG73qLXPXaLp8gIWDI1Aj22A6bs7stDJbkJa5hAdQ8",
    "https://i.picsum.photos/id/800/1500/300.jpg?hmac=1__4tUKLD17qNPuBQUfgrsuLXq40YtZk24U1h0_GakE",
    "https://picsum.photos/1500/300",
  ];
  return (
    <Carousel
      className={styles.banner}
      showStatus={false}
      showIndicators={false}
      transitionTime={500}
      interval={7000}
      autoPlay={true}
      infiniteLoop={true}
    >
      {banners.map((banner) => (
        <div
          className={styles.bannerImage}
          style={{ backgroundImage: `url(${banner})` }}
        />
      ))}
    </Carousel>
  );
};

export default Banner;
